import { useCallback } from 'react'
import { generatePath, useHistory, useLocation } from 'react-router-dom'

export const useRedirectTo = (
  path: string,
  options: Record<string, any> = {}
) => {
  const url = generatePath(path, options)
  const history = useHistory()

  return useCallback(() => {
    history.replace(url)
  }, [ history, url ])
}

export const useGoBackOrRedirect = (
  path: string,
  options: Record<string, any> = {}
) => {
  const url = generatePath(path, options)
  const history = useHistory()
  const location = useLocation()
 
  const handleGo = useCallback(() => {
    if (location.key) {
      history.goBack()
    }
    else {
      history.replace(url)
    }
  }, [ history, location.key, url ])

  return handleGo
}